import React from 'react';
import PropTypes from 'prop-types';

class Notifications extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <ul className="notifications">
      {this.props.children}
    </ul>
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/browser/components/header/notifications.js